import type { PlatformBridge } from './PlatformBridge';
import { nativeKeepAwake } from './iosKeepAwake';

interface WebkitWindow {
  webkit?: { messageHandlers?: Record<string, { postMessage(body: unknown): void }> };
}

// Native WKWebView shell. Paid-app model: no ads, no in-app purchases.
export const iosBridge: PlatformBridge = {
  platform: 'ios',
  // Routed to WebViewBridge's "review" handler, which calls StoreKit's AppStore.requestReview.
  // StoreKit alone decides whether the sheet actually appears (Apple caps it at ~3 per year) and
  // reports nothing back either way — so this is deliberately fire-and-forget.
  requestReview: () => {
    try {
      (window as unknown as WebkitWindow).webkit?.messageHandlers?.review?.postMessage({});
    } catch { /* handler not registered (older shell build) — no prompt, no error */ }
  },
  // Routed to WebViewBridge's "keepAwake" handler (UIApplication.isIdleTimerDisabled). Preferred
  // over navigator.wakeLock because WebKit only shipped that API in 16.4 and the app deploys to
  // 16.0 — but absent, so that the web API is used instead, on a shell that predates the handler.
  get keepAwake(): ((on: boolean) => void) | undefined {
    return nativeKeepAwake();
  },
};
